import { Map, Record } from 'immutable';
import { Utils } from '@kineticdata/bundle-common';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('services/submission');

export const selectActivityDetailsFromState = (id, state) => {
  const activityDetails = state.submission.activityDetails.get(id);
  return {
    activityDetailsLoading:
      !activityDetails && state.submission.activityDetails.has(id),
    activityDetails,
  };
};

export const selectActivityLogsFromState = (id, state) => {
  const activityLogs = state.submission.activityLogs.get(id);
  return {
    activityLogsLoading: !activityLogs && state.submission.activityLogs.has(id),
    activityLogsError:
      typeof activityLogs === 'object' && !Array.isArray(activityLogs)
        ? activityLogs
        : null,
    activityLogs: Array.isArray(activityLogs) ? activityLogs : null,
  };
};

export const types = {
  FETCH_SUBMISSION_REQUEST: ns('FETCH_SUBMISSION_REQUEST'),
  FETCH_SUBMISSION_SUCCESS: ns('FETCH_SUBMISSION_SUCCESS'),
  FETCH_SUBMISSION_FAILURE: ns('FETCH_SUBMISSION_FAILURE'),
  CLEAR_SUBMISSION_REQUEST: ns('CLEAR_SUBMISSION_REQUEST'),
  CLONE_SUBMISSION_REQUEST: ns('CLONE_SUBMISSION_REQUEST'),
  DELETE_SUBMISSION_REQUEST: ns('DELETE_SUBMISSION_REQUEST'),
  SET_PENDING_START: ns('SET_PENDING_START'),
  SET_PENDING_END: ns('SET_PENDING_END'),
  START_SUBMISSION_POLLER: ns('START_SUBMISSION_POLLER'),
  STOP_SUBMISSION_POLLER: ns('STOP_SUBMISSION_POLLER'),

  FETCH_ACTIVITY_DETAILS_REQUEST: ns('FETCH_ACTIVITY_DETAILS_REQUEST'),
  FETCH_ACTIVITY_DETAILS_COMPLETE: ns('FETCH_ACTIVITY_DETAILS_COMPLETE'),
  FETCH_ACTIVITY_LOGS_REQUEST: ns('FETCH_ACTIVITY_LOGS_REQUEST'),
  FETCH_ACTIVITY_LOGS_COMPLETE: ns('FETCH_ACTIVITY_LOGS_COMPLETE'),
};

export const actions = {
  fetchSubmissionRequest: withPayload(types.FETCH_SUBMISSION_REQUEST),
  fetchSubmissionSuccess: withPayload(types.FETCH_SUBMISSION_SUCCESS),
  fetchSubmissionFailure: withPayload(types.FETCH_SUBMISSION_FAILURE),
  clearSubmissionRequest: noPayload(types.CLEAR_SUBMISSION_REQUEST),
  cloneSubmissionRequest: withPayload(types.CLONE_SUBMISSION_REQUEST),
  deleteSubmissionRequest: withPayload(types.DELETE_SUBMISSION_REQUEST),
  setPendingStart: noPayload(types.SET_PENDING_START),
  setPendingEnd: noPayload(types.SET_PENDING_END),
  startSubmissionPoller: withPayload(types.START_SUBMISSION_POLLER),
  stopSubmissionPoller: noPayload(types.STOP_SUBMISSION_POLLER),

  fetchActivityDetailsRequest: withPayload(
    types.FETCH_ACTIVITY_DETAILS_REQUEST,
  ),
  fetchActivityDetailsComplete: withPayload(
    types.FETCH_ACTIVITY_DETAILS_COMPLETE,
  ),
  fetchActivityLogsRequest: withPayload(types.FETCH_ACTIVITY_LOGS_REQUEST),
  fetchActivityLogsComplete: withPayload(types.FETCH_ACTIVITY_LOGS_COMPLETE),
};

export const State = Record({
  error: null,
  data: null,
  activityDetails: Map(),
  activityLogs: Map(),
  pending: false,
});

const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_SUBMISSION_REQUEST:
      return state.data && state.data.id !== payload
        ? State()
        : state.set('error', null);
    case types.FETCH_SUBMISSION_SUCCESS:
      return state.set('data', payload);
    case types.FETCH_SUBMISSION_FAILURE:
      return state.set('error', payload);
    case types.CLEAR_SUBMISSION_REQUEST:
      return State();
    case types.CLONE_SUBMISSION_REQUEST:
    case types.DELETE_SUBMISSION_REQUEST:
    case types.SET_PENDING_START:
      return state.set('pending', true);
    case types.SET_PENDING_END:
      return state.set('pending', false);

    case types.FETCH_ACTIVITY_DETAILS_REQUEST:
      return state.update(
        'activityDetails',
        dtls => (dtls.has(payload.id) ? dtls : dtls.set(payload.id, null)),
      );
    case types.FETCH_ACTIVITY_DETAILS_COMPLETE:
      return payload.data
        ? state.setIn(['activityDetails', payload.id], payload.data)
        : state.deleteIn(['activityDetails', payload.id]);
    case types.FETCH_ACTIVITY_LOGS_REQUEST:
      return state.update(
        'activityLogs',
        logs => (logs.has(payload.id) ? logs : logs.set(payload.id, null)),
      );
    case types.FETCH_ACTIVITY_LOGS_COMPLETE:
      return state.setIn(['activityLogs', payload.id], payload.data);
    default:
      return state;
  }
};

export default reducer;
